import React, { FC, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { Button, Col, Row } from "reactstrap";
import SettingsForm from "./SettingsForm";
import { SettingOutlined } from "@ant-design/icons";
import FormInput from "../../form-components/InputComponent";
import FormSelect from "../../form-components/SelectComponent";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import FormDatePicker from "../../form-components/DatePicker";
import supplierApis from "../../../api/master/supplier";
import contractorsApis from "../../../api/master/contractors";
import sitesApis from "../../../api/master/sites";

const GeneralDetails: FC = (props: any) => {
  const {
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [settings, setSettings] = useState({
    open: false,
    data: {},
  });
  const [supplierOptions, setSupplierOptions] = useState<any[]>([]);
  const [contractorOptions, setContractorOptions] = useState<any[]>([]);

  const siteOptions = (currentUser?.siteAccessibility || []).map((item: any) => ({
    label: item.siteName,
    value: item.siteID?.toString(),
  }));

  const fetchSuppliers = async () => {
    try {
      const res = await supplierApis.fetchSupplierDropdown();
      if (res?.status && res?.data) {
        const options = res.data.map((item: any) => ({
          label: item.supplierName,
          value: item.supplierID?.toString(),
        }));
        setSupplierOptions(options);
      }
    } catch (error) {
      console.log("Error fetching suppliers:", error);
    }
  };

  const fetchContractors = async () => {
    try {
      const res = await contractorsApis.fetchContractorDropDown();
      if (res?.status && res?.data) {
        const options = res.data.map((item: any) => ({
          label: item.companyName,
          value: item.contractorID?.toString(),
        }));
        setContractorOptions(options);
      }
    } catch (error) {
      console.log("Error fetching contractors:", error);
    }
  };

  const selectedSiteId = watch("siteId");

  const fetchSegmentLevel = async (siteId: string) => {
    try {
      const { data, status } = await sitesApis.fetchSegmentLevelBySiteId(siteId);
      if (status && data) {
        const level = typeof data === "string" ? data : data.segmentLevel || data.segment || null;
        setValue("segmentLevel", level);
      } else {
        setValue("segmentLevel", null);
      }
    } catch (error) {
      console.log("Error fetching segment level:", error);
      setValue("segmentLevel", null);
    }
  };

  useEffect(() => {
    if (selectedSiteId) {
      fetchSegmentLevel(selectedSiteId);
    } else {
      setValue("segmentLevel", null);
    }
  }, [selectedSiteId]);

  useEffect(() => {
    setFormValues();
    fetchSuppliers();
    fetchContractors();
  }, []);
  const setFormValues = () => {
    setSettings((prev) => ({
      ...prev,
      data: {
        deliveryLineLevel: "true",
        approvalToPublish: "true",
        questionerForEligibility: "true",
        approvalForEvaluation: "true",
        documnetsRequired: "true",
      },
    }));
  };
  const openSettingsForm = () => {
    console.log("settings", settings);
    setSettings((prev) => ({
      ...prev,
      open: true,
    }));
  };
  const handleSettingsSubmit = (updatedSettings: any) => {
    console.log("updatedSettings", updatedSettings);
    setSettings({
      open: false,
      data: updatedSettings,
    });
    setValue("deliveryLineLevel", updatedSettings.deliveryLineLevel);
    setValue("approvalToPublish", updatedSettings.approvalToPublish);
    setValue(
      "questionerForEligibility",
      updatedSettings.questionerForEligibility
    );
    setValue("approvalForEvaluation", updatedSettings.approvalForEvaluation);
    setValue("documnetsRequired", updatedSettings.documnetsRequired);
  };
  const submitForm = (data: any) => {
    props?.next();
  };
  return (
    <>
      <Row>
        <div
          style={{ justifyContent: "end", display: "flex", marginTop: "-2%" }}
        >
          <Button color="neutral" onClick={openSettingsForm}>
            Settings &nbsp; <SettingOutlined />
          </Button>
        </div>
      </Row>
      <SettingsForm
        open={settings.open}
        onClose={() => {
          setSettings((pre) => {
            return {
              ...pre,
              open: false,
            };
          });
        }}
        initialValues={settings.data}
        onSubmit={handleSettingsSubmit}
      />
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <Row className="gy-4">
          <Col lg="4">
            <FormInput
              name="tenderNumber"
              label="Tender #"
              required={true}
              type="text"
              minLength={2}
              placeholder="Enter Tender #"
              tooltipText="Enter a Tender #."
            />
          </Col>
          <Col lg="4">
            <FormInput
              name="tenderTitle"
              label="Tender Title"
              required={true}
              type="text"
              minLength={2}
              maxLength={200}
              placeholder="Enter Tender Title"
              tooltipText="Enter the title of the tender."
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="tenderType"
              label={`Tender Type`}
              options={[
                {
                  value: "Open",
                  label: "Open",
                },
                {
                  value: "Restricted",
                  label: "Restricted",
                },
              ]}
              required={true}
              placeholder="-Select-"
              tooltipText="Select the Type of the Tender."
            />
          </Col>
          <Col lg="8">
            <FormInput
              name="description"
              label="Description"
              required={true}
              type="text"
              minLength={2}
              maxLength={200}
              placeholder="Enter Description"
              tooltipText="Enter a brief description of the purchase order."
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="tenderFor"
              label={`Tender For`}
              options={[
                {
                  value: "Material",
                  label: "Material",
                },
                // {
                //   value: "Service / Works",
                //   label: "Service / Works",
                // },
              ]}
              required={true}
              placeholder="-Select-"
              tooltipText="Select the Tender For."
            />
          </Col>
          {watch("tenderFor") === "Material" && (
            <Col lg="4">
              <FormSelect
                name="siteId"
                label={`Site`}
                options={siteOptions}
                required={true}
                placeholder="-Select-"
                tooltipText="Select the site where the materials will be used."
              />
            </Col>
          )}
          {watch("tenderFor") === "Service / Works" && (
            <Col lg="4">
              <FormSelect
                name="projectId"
                label={`Project`}
                options={siteOptions}
                required={false}
                placeholder="-Select-"
                tooltipText="Select the Project where the services/works will be provided."
              />
            </Col>
          )}
          {watch("tenderType") === "Restricted" &&
            watch("tenderFor") === "Material" && (
              <Col lg="4">
                <FormMultiSelect
                  name="supplierIds"
                  label={`Suppliers`}
                  options={supplierOptions}
                  required={false}
                  placeholder="-Select Suppliers-"
                  tooltipText="Select the Suppliers for this restricted tender."
                />
              </Col>
            )}
          {watch("tenderType") === "Restricted" &&
            watch("tenderFor") === "Service / Works" && (
              <Col lg="4">
                <FormMultiSelect
                  name="contractorIds"
                  label={`Contractors`}
                  options={contractorOptions}
                  required={false}
                  placeholder="-Select Contractors-"
                  tooltipText="Select the Contractors for this restricted tender."
                />
              </Col>
            )}
          <Col lg="4">
            <FormDatePicker
              name="lastSubmissionDate"
              label="Last Submission Date"
              required={true}
              showTime={true}
              minDate={new Date()}
            />
          </Col>
          <Col lg="4">
            <FormDatePicker
              name="lastDateForExpressingInterest"
              label="Last Date For Expressing Interest"
              required={true}
              showTime={true}
              minDate={new Date()}
              maxDate={
                watch("lastSubmissionDate")
                  ? new Date(
                      new Date(watch("lastSubmissionDate")).setDate(
                        new Date(watch("lastSubmissionDate")).getDate() - 1
                      )
                    )
                  : undefined
              }
            />
          </Col>
          <Col lg="4">
            <FormDatePicker
              name="evaluationStartDate"
              label="Evaluation Start Date"
              required={true}
              showTime={true}
              minDate={
                watch("lastSubmissionDate")
                  ? new Date(watch("lastSubmissionDate"))
                  : new Date()
              }
            />
          </Col>
          <Col lg="4">
            <FormDatePicker
              name="sealedBidSubmissionDate"
              label="Sealed Bid Submission Date"
              // required={true}
              showTime={true}
              minDate={new Date()}
              maxDate={
                watch("lastSubmissionDate")
                  ? new Date(watch("lastSubmissionDate"))
                  : undefined
              }
            />
          </Col>
          <Col lg="8">
            <FormInput
              name="sealedBidPostalAddress"
              label="Sealed Bid Postal Address"
              // required={true}
              type="text"
              placeholder="Enter Sealed Bid Postal Address"
              tooltipText="Enter the postal address for sealed bid submissions."
            />
          </Col>
        </Row>
        <Row className="gy-4 mt-1">
          <Col>
            <Button color="primary" type="submit">
              Next
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default GeneralDetails;
